// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3UKME","resendInfoText":"OnGoingPaymentBox_resendInfoText__2NxRP"};